import React from 'react'
import CategoryCarousel from '../../CategoryCarousel/CategoryCarousel'
import HomePageSideBar from '../../HomePageSideBar/HomePageSideBar'
import FirstTab from '../FirstTab'

const MiddleSection = () => {
    return (
        <>
            <section className="main-wrap">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-3">
                            <HomePageSideBar/>
                        </div>
                        <CategoryCarousel />
                    </div>
                </div>
            </section>
        </>
    )
}

export default MiddleSection